import React from 'react';
import PropTypes from 'prop-types';

export const Textarea = ({
  className = '',
  rows = 3,
  ...props
}) => {
  return (
    <textarea
      className={`
        w-full rounded-md border border-gray-300 dark:border-white/10 bg-gray-300 dark:bg-zinc-900 text-black dark:text-white
        px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all
        ${className}
      `}
      rows={rows}
      {...props}
    />
  );
};

Textarea.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.number,
};